import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteTaxZone } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useDeleteTaxZone = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteTaxZoneMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteTaxZone,
        onSuccess: (res) => {
            toast.success(res.message || "Tax zone deleted successfully");
            queryClient.invalidateQueries(["tax-zones"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete tax zone");
        },
    });

    return { deleteTaxZoneMutate, isDeleting };
};
